import { create } from "zustand";
import { devtools } from "zustand/middleware";

type TAppBreadcrumbState = {
  label?: string;
};

type TAppBreadcrumbStore = TAppBreadcrumbState & {
  setLabel: (label?: string) => void;
};

const initialState: TAppBreadcrumbState = {
  label: undefined,
};

export const useAppBreadcrumbStore = create<TAppBreadcrumbStore>()(
  devtools(set => ({
    ...initialState,
    setLabel: (label?: string) => set({
      label,
    }),
  })),
);
